export class MarkerModel {
    public toCompanyId!: string;
    public sequence!: number;
    public coordinates!: number[];
    public stepID!: string;
    public stepName!: string;
}